var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H29V34H10V4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05477 0H33.9452C35.0262 0 36 0.973768 36 2.05477V33.9452C36 35.0262 35.0262 36 33.9452 36H2.05477C0.973768 36 0 35.0262 0 33.9452V2.05477C0 0.973768 0.973768 0 2.05477 0ZM18.8153 20.2139H23.7879L24.0041 15.4575H18.8153V11.9447C18.8153 10.5938 19.0851 9.83626 20.8147 9.83626H23.8415L23.9505 5.40329C23.9505 5.40329 22.5997 5.18709 20.6539 5.18709C15.8974 5.18709 13.7891 8.16028 13.7891 11.3497V15.4575H10.2762V20.2139H13.7891V33.4021H18.8153V20.2139Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbNew);
export default __webpack_public_path__ + "static/media/fb-new.19b92ae7b15df65eb9b8642f85c7ca20.svg";
export { ForwardRef as ReactComponent };